import Marionette from "backbone.marionette";
import Moment from "moment";

import CSS from "views/goodsDetail/goodsDetail.css";
import GoodsTpl from "views/goodsDetail/goodsDetailView.ejs";
//Secondary
import AcuerdosTpl from "views/goodsDetail/sections/acuerdos.ejs";
import CatastralesTpl from "views/goodsDetail/sections/catastrales.ejs";
import MejorasTpl from "views/goodsDetail/sections/mejoras.ejs";
import RegistralesTpl from "views/goodsDetail/sections/registrales.ejs";
import TitulosTpl from "views/goodsDetail/sections/titulos.ejs";
import DocumentTpl from "views/goodsDetail/sections/documentos.ejs";

import ParametersModel from "models/parametersModel.js";

var parametersModel = new ParametersModel();

import LogModel from "models/logsModel.js";

var logModel = new LogModel();

// import Amortizacion from "models/amortizacion.js";

import GoodModel from "models/goodModel.js";

import S from "session/session.js";
import T from "session/token.js";

var storeModel = new Backbone.Model();
var bootbox = require('bootbox');

// Required fields
/*var requiredFields = [
    "entity", "denominacion", "juridicos_situacionPatrimonial", "juridicos_uso", "juridicos_tipoAdquisicion", "juridicos_fechaAdquisicion"
    //// "entity", "denominacion", "juridicos_situacionPatrimonial", "juridicos_uso", "juridicos_tipoAdquisicion", "juridicos_fechaAdquisicion", "juridicos_costeAdquisicion", "economicos_valorrazonable"
];
*/

var requiredFields = [
    "entity"

];
var errorRequiredFields = [];





//Definition of group fields according to epigraphs
var related = {


    0: ["EPIGRAPH_1", "EPIGRAPH_2", "EPIGRAPH_3", "EPIGRAPH_4", "EPIGRAPH_5", "EPIGRAPH_6", "EPIGRAPH_7", "EPIGRAPH_83",
        "EPIGRAPH_84", "EPIGRAPH_88", "EPIGRAPH_94"
    ],
    1: ["EPIGRAPH_8"],

    3: ["EPIGRAPH_13", "EPIGRAPH_14", "EPIGRAPH_15", "EPIGRAPH_16", "EPIGRAPH_17", "EPIGRAPH_23", "EPIGRAPH_24"],

    5: ["EPIGRAPH_18", "EPIGRAPH_19"],
    6: ["EPIGRAPH_21"],

    8: ["EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27", "EPIGRAPH_28"],

    9: ["EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_32", "EPIGRAPH_33", "EPIGRAPH_34", "EPIGRAPH_45",
        "EPIGRAPH_46", "EPIGRAPH_47", "EPIGRAPH_48", "EPIGRAPH_49", "EPIGRAPH_50", "EPIGRAPH_51", "EPIGRAPH_52", "EPIGRAPH_53",
        "EPIGRAPH_54", "EPIGRAPH_55", "EPIGRAPH_56", "EPIGRAPH_57", "EPIGRAPH_58", "EPIGRAPH_59", "EPIGRAPH_60", "EPIGRAPH_61",
        "EPIGRAPH_62", "EPIGRAPH_63", "EPIGRAPH_65", "EPIGRAPH_66", "EPIGRAPH_67", "EPIGRAPH_68", "EPIGRAPH_69", "EPIGRAPH_71",
        "EPIGRAPH_72", "EPIGRAPH_73", "EPIGRAPH_74", "EPIGRAPH_75", "EPIGRAPH_76", "EPIGRAPH_77", "EPIGRAPH_78", "EPIGRAPH_79",
        "EPIGRAPH_80", "EPIGRAPH_81", "EPIGRAPH_90", "EPIGRAPH_93"
    ],

    11: ["EPIGRAPH_11"],
    12: ["EPIGRAPH_10", "EPIGRAPH_89", "EPIGRAPH_95"],
    13: ["EPIGRAPH_9"],
    14: ["EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37", "EPIGRAPH_38", "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41", "EPIGRAPH_42",
        "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_64", "EPIGRAPH_70"
    ],
    15: ["EPIGRAPH_82"],
    16: ["EPIGRAPH_20", "EPIGRAPH_22"],
    17: ["EPIGRAPH_87"],
    18: ["  "],
    19: ["EPIGRAPH_12"],
    20: ["EPIGRAPH_91", "EPIGRAPH_92"],
    21: ["EPIGRAPH_85", "EPIGRAPH_86"],
    22: ["EPIGRAPH_96", "EPIGRAPH_97"],
};


var hideCatastralesEpigraphs = [
    "EPIGRAPH_8",
    //// "EPIGRAPH_5",
    "EPIGRAPH_13", "EPIGRAPH_14", "EPIGRAPH_15", "EPIGRAPH_16", "EPIGRAPH_17", "EPIGRAPH_20", "EPIGRAPH_22", "EPIGRAPH_23", "EPIGRAPH_24",
    ////"EPIGRAPH_14",
    "EPIGRAPH_18", "EPIGRAPH_19",
    "EPIGRAPH_21",
    "EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27", "EPIGRAPH_28",
    "EPIGRAPH_12", "EPIGRAPH_29", "EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_32", "EPIGRAPH_33", "EPIGRAPH_34", "EPIGRAPH_45",
    "EPIGRAPH_46", "EPIGRAPH_47", "EPIGRAPH_48", "EPIGRAPH_49", "EPIGRAPH_50", "EPIGRAPH_51", "EPIGRAPH_52", "EPIGRAPH_53",
    "EPIGRAPH_54", "EPIGRAPH_55", "EPIGRAPH_56", "EPIGRAPH_57", "EPIGRAPH_58", "EPIGRAPH_59", "EPIGRAPH_60", "EPIGRAPH_61",
    "EPIGRAPH_62", "EPIGRAPH_63", "EPIGRAPH_65", "EPIGRAPH_66", "EPIGRAPH_67", "EPIGRAPH_68", "EPIGRAPH_69", "EPIGRAPH_71",
    "EPIGRAPH_72", "EPIGRAPH_73", "EPIGRAPH_74", "EPIGRAPH_75", "EPIGRAPH_76", "EPIGRAPH_77", "EPIGRAPH_78", "EPIGRAPH_79",
    "EPIGRAPH_80", "EPIGRAPH_81",
    "EPIGRAPH_81",
    "EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37", "EPIGRAPH_38", "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41", "EPIGRAPH_42",
    "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_64", "EPIGRAPH_70", "EPIGRAPH_96", "EPIGRAPH_97"
];



/*
 

//Definition of group fields according to epigraphs
var related = {
    0: ["EPIGRAPH_1", "EPIGRAPH_2", "EPIGRAPH_5", "EPIGRAPH_39", "EPIGRAPH_40"],
    1: ["EPIGRAPH_3"],
    2: ["EPIGRAPH_4", "EPIGRAPH_13", "EPIGRAPH_46"],
    3: ["EPIGRAPH_6", "EPIGRAPH_8"],
    4: ["EPIGRAPH_7", "EPIGRAPH_9"],
    5: ["EPIGRAPH_10", "EPIGRAPH_11"],
    6: ["EPIGRAPH_12"],
    7: ["EPIGRAPH_14"],
    8: ["EPIGRAPH_15", "EPIGRAPH_16"],
    9: ["EPIGRAPH_17", "EPIGRAPH_18", "EPIGRAPH_19", "EPIGRAPH_20", "EPIGRAPH_21", "EPIGRAPH_22", "EPIGRAPH_23", "EPIGRAPH_24",
        "EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27", "EPIGRAPH_28", "EPIGRAPH_29", "EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_33",
        "EPIGRAPH_34", "EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37", "EPIGRAPH_38", "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41"
    ],
    10: ["EPIGRAPH_32"],
    11: ["EPIGRAPH_42", "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_45"]
};

var hideCatastralesEpigraphs = [
    "EPIGRAPH_3",
    "EPIGRAPH_5",
    "EPIGRAPH_10", "EPIGRAPH_11", "EPIGRAPH_12", "EPIGRAPH_13",
    "EPIGRAPH_14",
    "EPIGRAPH_15", "EPIGRAPH_16", "EPIGRAPH_17", "EPIGRAPH_18", "EPIGRAPH_19", "EPIGRAPH_20", "EPIGRAPH_21", "EPIGRAPH_22", "EPIGRAPH_23",
    "EPIGRAPH_24", "EPIGRAPH_25", "EPIGRAPH_26", "EPIGRAPH_27", "EPIGRAPH_28", "EPIGRAPH_29", "EPIGRAPH_30", "EPIGRAPH_31", "EPIGRAPH_32",
    "EPIGRAPH_33", "EPIGRAPH_34", "EPIGRAPH_35", "EPIGRAPH_36", "EPIGRAPH_37", "EPIGRAPH_38",
    "EPIGRAPH_39", "EPIGRAPH_40", "EPIGRAPH_41", "EPIGRAPH_42", "EPIGRAPH_43", "EPIGRAPH_44", "EPIGRAPH_45",
    "EPIGRAPH_46",
];

 
 */






var SectionView = Marionette.View.extend({
    initialize: function(data) {
        this.template = data.template;
    },
    render: function() {
        this
            .$el
            .html(this.template);
    }
});

export default Marionette.LayoutView.extend({
    initialize: function(data) {
        $("#loaderContainer").show();

        $('.content-wrapper').css({ 'margin-left': '230px' });


        this.viewable = data.view;

        this.idGood = data.id;

        var isEditable_lol = 2;

        if (data.editable_i >= 0) {
            isEditable_lol = data.editable_i;
        }

        this.isEditableGood = isEditable_lol;

        this.isNuevo = true;

        if (data.id || S.userInfo.get("role") > 2) { //Si tiene id el bien existe (no se modifica). Pasa lo mismo si el usuario no tiene permiso
            this.isNuevo = false;
        }



        if (data.id) {
            this.id = data.id;
            this.model = new GoodModel({
                id: parseInt(data.id)
            });
        } else {
            this.model = new GoodModel();
            this.model.set({ "epigraph": "EPIGRAPH_1" });
        }

        this.lang = data.lang;

        this.listenTo(S.mApp, "templatesLoaded", this.applyTemplates.bind(this));
        this.listenTo(S.mApp, "formReady", this.formReady.bind(this));
    },
    files: [],
    snap: false,
    formData: {},
    template: GoodsTpl,
    render: function() {
        parametersModel.fetch({
            data: {
                instanceId: S.instanceId,
                epigracheck: 'epigraffeee'
            },
            beforeSend: T.useToken,
            success: function() {
                if (this.id) {
                    this.model.fetch({
                        data: {
                            instanceId: S.instanceId
                        },
                        beforeSend: T.useToken,
                        success: this.applyView.bind(this)
                    });
                } else {
                    this.applyView();
                }
            }.bind(this)
        });
    },
    map: null,
    applyView: function() {
        if (S.userInfo.get("role") > 1)
            this.consultaBaja();
        storeModel.set(this.model.toJSON());
        this.$el.html(this.template({
            attributes: this.model.attributes,
            lang: this.lang,
            viewable: this.viewable,
            parameters: parametersModel.toJSON(),
            id_good: this.idGood,
            rooll: S.userInfo.get("role"),
            isEditableBien: this.isEditableGood,
            nuevo: this.isNuevo,
            iduser_get: S.userInfo.get("id"),

        }));


        $("#backButton").removeClass("hidden");


        this.isEditableGood = this.isEditableGood;


        this.loadTemplates(this.model.get("epigraph"));
    },

    consultaBaja: function() {
        $.ajax({
            url: "/api/permissions/permibaj.php",
            type: 'GET',
            data: { "user": S.userInfo.id, "instanceId": S.instanceId, "option": this.model.attributes.epigraph },
            success: function(result) {

                if (result == 0) {
                    //console.log ("soy no modificable");
                    $("#baja").prop('disabled', true);
                    $("#fechaBaja").prop('disabled', true);
                    $("#motivoBaja").prop('disabled', true);

                } else {
                    //console.log("Soy  modificable");
                    $("#baja").prop('disabled', false);
                    $("#fechaBaja").prop('disabled', false);
                    $("#motivoBaja").prop('disabled', false);

                }

            }
        });


        /////comprobar si hay puede modificar las sections. 
        this._checkDisableSections();


    },

    hideCatastrales: function(epigraph) {

        if (hideCatastralesEpigraphs.indexOf(epigraph) >= 0) {
            return true;
        } else {
            return false;
        }

    },
    loadTemplates: function(epigraph) {

        this.model.attributes.epigraph = epigraph;

        $("#loaderContainer").show();
        var group;
        for (var r in related) {

            for (var e in related[r]) {

                if (epigraph === related[r][e])
                    group = r;
            }
        }



        var econoniim = $('#economicos_valorrazonable').val();




        var files = ["acuerdos", "incidencias", "descriptivos", "documentos", "economicos", "gps", "juridicos", "mejoras", "registrales", "catastrales", "seguros",
            "titulos", "urbanisticos"
        ];


        var templates = [];
        var j = files.length - 1;
        var hideCatastral = this.hideCatastrales(epigraph);


        // Load templates recursively
        function loadTemplate() {

            if (j === -1) {
                S.mApp.trigger("templatesLoaded", templates);
                return;
            } else {
                //Para los paneles
                $.ajax({
                    url: "sections/" + group + "/" + files[j] + ".ejs",
                    success: function(template) {
                        var form = document.createElement("div");
                        form.innerHTML = template;
                        templates[
                            form
                            .firstChild
                            .getAttribute("id")
                        ] = _.template(template);
                        $('.tab-content .money').mask("#.##0,00", { reverse: true });
                        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
                        $('.tab-content .integer').mask("#.##0", { reverse: true });
                        $('.tab-content .number').mask("##0", { reverse: true });



                    }
                }).always(function() {
                    loadTemplate();
                    j--;
                });
            }
        }


        loadTemplate();
    },
    applyTemplates: function(templates) {


        var isEditableElBien = this.isEditableGood;


        //Individual section
        $("#descriptivos").html(templates.descriptivos({
            attributes: this.model.attributes || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));

        $("#incidencias").html(templates.incidencias({
            attributes: this.model.attributes.incidencias || {},
            viewable: this.viewable,
            lang: this.lang
        }));
        /*
                $("#ampliada").html(templates.ampliada({
                    attributes: this.model.attributes.ampliada || {},
                    viewable: this.viewable,
                    lang: this.lang
                }));*/

        $("#mejoras").html(templates.mejoras({
            encurso: $('#enCurso').is(':checked'),
            encursoBack: this.model.attributes.enCurso,
            attributes: this.model.attributes.mejoras || {},
            epi: this.model.attributes.epigraph,
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));


        var disableVidautl = "disabled";
        var valorRazona_id = parseInt(this.model.attributes.economicos_valorrazonable);

        if (valorRazona_id > 0) {
            disableVidautl = "";
        }

        var disableOnlySuperAdmin = "disabled";
        if (S.userInfo.get("role") == 0) {
            disableOnlySuperAdmin = "";
        }

        $("#economicos").html(templates.economicos({
            encurso: $('#enCurso').is(':checked'),
            encursoBack: this.model.attributes.enCurso,
            attributes: this.model.attributes || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON(),
            disableVa: disableVidautl,
            disableSoloAdmin: disableOnlySuperAdmin
        }));

        $("#gps").html(templates.gps({
            attributes: this.model.attributes.gps || {},
            viewable: this.viewable,
            lang: this.lang
        }));

        $("#juridicos").html(templates.juridicos({
            attributes: this.model.attributes || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));

        $("#seguros").html(templates.seguros({
            attributes: this.model.attributes.seguros || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));

        $("#urbanisticos").html(templates.urbanisticos({
            attributes: this.model.attributes.urbanisticos || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));

        $("#registrales").html(templates.registrales({
            attributes: this.model.attributes.registrales || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));



        $("#catastrales").html(templates.catastrales({
            attributes: this.model.attributes.catastrales || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));

        $("#acuerdos").html(templates.acuerdos({
            attributes: this.model.attributes.acuerdos || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));


        $("#titulos").html(templates.titulos({
            attributes: this.model.attributes.titulos || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON()
        }));

        $("#documentos").html(templates.documentos({
            attributes: this.model.attributes.documentos || {},
            viewable: this.viewable,
            lang: this.lang,
            parameters: parametersModel.toJSON(),
            t_oken: S.token
        }));


        var documentos = this.model.attributes.documentos;

        for (var d in documentos) {
            $("#documentosList").append(DocumentTpl({
                attributes: documentos[d],
                lang: this.lang,
                idInstance: S.instanceId,
                t_oken: S.token
            }));
        }


        if (isEditableElBien == 0) {
            $('#addDocument').hide();

            $('form#documentosList .unbreakable').hide();
        }
        //hide empty forms
        for (var i = 0; i < document.forms.length; i++) {
            var id = document.forms[i].getAttribute("id");
            if (!document.forms[i].elements.length) {
                $("#" + id + "-tab").hide();
                $("#" + id + "-list").addClass("hidden");
                $(".tab-pane#" + id).addClass("hidden");
            } else {
                $("#" + id + "-tab").show();
                $("#" + id + "-list").removeClass("hidden");
                $(".tab-pane#" + id).removeClass("hidden");
            }
        }

        /// GPS //////////////////////////////////////////////// /
        // TODO: Ordenar estas funciones. Abstraer fuera. Tener en cuenta que Geocoder
        // tiene un callback
        if (document.querySelector("form#gps").elements.length) {
            var location;
            var geocoder = new google.maps.Geocoder();
            var address;

            if (this.model.attributes.gps && this.model.attributes.gps.gps_latitude && this.model.attributes.gps.gps_longitude) {
                location = new google.maps.LatLng(this.model.attributes.gps.gps_latitude, this.model.attributes.gps.gps_longitude);
                this.map = new google.maps.Map(document.getElementById('map'), {
                    zoom: 18,
                    center: location,
                    mapTypeId: 'roadmap',
                    zoomControl: true,
                    mapTypeControl: false,
                    scaleControl: false,
                    streetViewControl: false,
                    rotateControl: false,
                    fullscreenControl: false
                });

                this.marker = new google.maps.Marker({ position: location, map: this.map });
            } //if
            else {
                address = $("#descriptivos_direccion").val() + " " + $("#descriptivos_codigoPostal").val() + " " + $("#descriptivos_nucleoUrbano").val();


                geocoder.geocode({
                    'address': address
                }, function(results, status) {


                    if (status === 'OK') {
                        location = results[0].geometry.location;

                        $("#gps_latitude").val(location.lat());
                        $("#gps_longitude").val(location.lng());

                        this.map = new google.maps.Map(document.getElementById('map'), {
                            zoom: 18,
                            center: location,
                            mapTypeId: 'roadmap',
                            zoomControl: true,
                            mapTypeControl: false,
                            scaleControl: false,
                            streetViewControl: false,
                            rotateControl: false,
                            fullscreenControl: false
                        });

                        this.marker = new google.maps.Marker({ position: location, map: this.map });

                    } //if status
                    else {


                        $("#gps_latitude").val(parametersModel.toJSON().gpsDefaultsData[0].latitude);
                        $("#gps_longitude").val(parametersModel.toJSON().gpsDefaultsData[0].longitude);
                    } //else status
                }.bind(this)); //function
            } //else




            if (this.map) {
                google.maps.event.addListener(this.map, 'click', function(event) {
                    $("#gps_latitude").val(event.latLng.lat());
                    $("#gps_longitude").val(event.latLng.lng());
                    this.marker.setPosition(event.latLng);
                }.bind(this));
            }
        }

        /// MASTERS (1-n) //////////////////////////////////////// /
        if (document.querySelector("form#mejoras").elements.length) {
            var mejoras = this.model.attributes.mejoras;
            for (var m in mejoras) {

                var textDisabled = 'disabled';
                if (S.userInfo.get("role") == 0) {
                    textDisabled = '';
                }


                var tr = document.createElement('tr');
                tr.innerHTML = MejorasTpl({
                    attributes: mejoras[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang,
                    disabledcheck: textDisabled,
                    encurso: $('#enCurso').is(':checked'),
                    encursoBack: this.model.attributes.enCurso,
                    epi: this.model.attributes.epigraph,
                    isnuevamejora: -1
                });
                tr.className = "valueList mejorasItem";
                var table = document.getElementById("mejorasList");
                table.tBodies[0].appendChild(tr);
            }



            if (isEditableElBien == 0) {
                $('#addMejora').hide();

                $('form#mejoras .unbreakable').hide();
            }


        }

        // this.calculateAmortizacion();

        if (document.querySelector("form#acuerdos").elements.length) {
            var acuerdos = this.model.attributes.acuerdos;
            for (var m in acuerdos) {
                var tr = document.createElement('tr');
                tr.innerHTML = AcuerdosTpl({
                    attributes: acuerdos[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang
                });
                tr.className = "valueList";
                var table = document.getElementById("acuerdosList");
                table.tBodies[0].appendChild(tr);
            }


            if (isEditableElBien == 0) {
                $('#addAcuerdo').hide();

                $('form#acuerdos .unbreakable').hide();
            }

        }




        if (this.hideCatastrales(this.model.attributes.epigraph)) {
            // Not showing catastrales
            $("#catastrales").addClass("hidden");
            $("#catastrales-list").addClass("hidden");
            $("#catastrales-tab").addClass("hidden");
        } else {
            if (document.querySelector("form#catastrales").elements.length) {
                var catastrales = this.model.attributes.catastrales;


                for (var m in catastrales) {
                    var tr = document.createElement('tr');
                    tr.innerHTML = CatastralesTpl({
                        attributes: catastrales[m],
                        parameters: parametersModel.toJSON(),
                        lang: this.lang
                    });
                    tr.className = "valueList";
                    var table = document.getElementById("catastralesList");
                    table.tBodies[0].appendChild(tr);
                }


                if (isEditableElBien == 0) {

                    $('#addCatastral').hide();

                    $('form#catastrales .unbreakable').hide();
                }


            }
        }

        if (document.querySelector("form#registrales").elements.length) {
            var registrales = this.model.attributes.registrales;
            for (var m in registrales) {
                var tr = document.createElement('tr');
                tr.innerHTML = RegistralesTpl({
                    attributes: registrales[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang
                });
                tr.className = "valueList";
                var table = document.getElementById("registralesList");
                table.tBodies[0].appendChild(tr);
            }


            if (isEditableElBien == 0) {

                $('#addRegistral').hide();

                $('form#registrales .unbreakable').hide();
            }


        }



        /////  $('#titulosList tbody').empty();

        if (document.querySelector("form#titulos").elements.length) {
            var titulos = this.model.attributes.titulos;

            for (var m in titulos) {
                var tr = document.createElement('tr');


                tr.innerHTML = TitulosTpl({
                    attributes: titulos[m],
                    parameters: parametersModel.toJSON(),
                    lang: this.lang
                });
                tr.className = "valueList";
                /////var table = document.getElementById("titulosList");
                var table = document.getElementById("titulosList").getElementsByTagName('tbody')[0];
                table.appendChild(tr);
            }


            if (isEditableElBien == 0) {

                $('#addTitulo').hide();
                $('form#titulos .unbreakable').hide();
            }


        }


        //Initialize date picker components
        $("#dtpickerAlta, #dtpickerBaja, #dtpickerCursoIni, #dtpickerCursoFin, #dtpickerfechaTitulo, #dtpickerAcuerdos, #dtpickerRegis" +
            "trales, #dtpickerFechaAdquisicion,#dtpickerFechaCesion, #dtpickerfechaVencimiento, #dtpickerSeguroInicio, #dtpickerSeguroVencimiento, #dtpickerPlaneamiento, #dtpickerDerivado, #dtp" +
            "ickerPlanemiento, #dtpickerPlanemientoD, #dtpickerInicio, #dtpickerDocumentos,#dt" +
            "pickerVencimiento, #dtpickerRegistrales, #dtpickerfechaReposicion, #dtpickerfechaRevision, #dtpickerfech" +
            "aMercado,  #dtpickerfechavalorrazonable,  #dtpickerTitulo, #dtpickerMejoras, #dtpickerIncidencias").datetimepicker({ format: 'DD/MM/YYYY' });

        $("#loaderContainer").hide();

        $('.money').mask("#.##0,00", { reverse: true });
        $('.decimal').mask("#.##0,00", { reverse: true });
        $('.integer').mask("#.##0", { reverse: true });
        $('.number').mask("##0", { reverse: true });



        //Initialize with list view by default
        this.listView();

        /*
        = Vamos a consultar las secciones =
        */
        this._checkDisableSections();

        // Add validation classes
        $.each(requiredFields, function() {
            $("#" + this).addClass("isRequired");
        });


    },
    events: {
        "click #send": "submit",
        "change #epigraph": "changeForms",
        "click #tabView": "tabView",
        "click #listView": "listView",
        "dp.change #dtpickerFechaAdquisicion, .dtpickerMejoras": "calculateAmortizacion",
        "input .mejorasItem #mejoras_importe, #juridicos_costeAdquisicion": "calculateAmortizacion",
        "change .mejorasItem #mejoras_cuenta, #economicos_cuenta": "recalculateCuentas",
        "shown.bs.tab a#gps-tab[data-toggle='tab']": "showMap",
        "change .inputField  #baja": "checkBaja",
        "change .inputField  #enCurso": "checkCurso",
        "click #addMejora": "addMejora",
        "click #mejorasList .remove": "removeMejora",
        "click #addAcuerdo": "addAcuerdo",
        "click #acuerdosList .remove": "removeAcuerdo",
        "click #addCatastral": "addCatastral",
        "click #catastralesList .remove": "removeCatastral",
        "click #addRegistral": "addRegistral",
        "click #registralesList .remove": "removeRegistral",
        "click #addTitulo": "addTitulo",
        "click #titulosList .remove": "removeTitulo",
        "click #addDocument": "addDocument",
        "click .documentosItem .remove": "removeDocument",
        "change #descriptivos_url": "checkFile",
        "click #history": "historyList",
        "click .container-fluid": "hideOptions",
        "click #historyList a": "selectHistory",
        "click #clone": "clone",
        "click #pdf": "exportPDF",
        "click #amortizaciones": "saveAmortizaciones",
        "keyup #economicos_valorrazonable": "changeVidaUtill",
        "keyup #economicos_vidaUtil": "changePorcenAmortiza",
        "click #vvv": "changeForms2",
        "change #mejoras_encurso": "changeMejoras",
        "change input#mejoras_vida": "Changemejoras_vida"


    },
    /* recalculateCuentas: function(ev) {
        var cuentas = parametersModel.attributes.amortizaciones;
        var cuenta = cuentas[0];
        for (var i in cuentas) {
            if ($(ev.target).val() === cuentas[i].item) {
                cuenta = cuentas[i];
            }
        }

        //If we're on the economicos page
        if ($(ev.target).attr("id") === "economicos_cuenta") {
            $("#economicos_vidaUtil").val(cuenta.vida_util);
            $("#economicos_amortizacion").val(cuenta.amortizacion);
        } else {
            //we're on the mejoras page
            $(ev.target).parents(".mejorasItem").find("#mejoras_vida").val(cuenta.vida_util);
            $(ev.target).parents(".mejorasItem").find("#mejoras_amortizacion").val(cuenta.amortizacion);
        }

        this.calculateAmortizacion();
    },
    calculateAmortizacion: function() {
        // Mejoras
        var vncMejorasTotal = 0;
        var amortAcumuladaMejorasTotal = 0;
        var valorMejoras = 0;
        
        
        $(".mejorasItem").each(function() {
            var mejoraData = {
                fechaAdquisicion: $(this).find("#mejoras_fecha").val(),
                vidautil_codigo: Number($(this).find("#mejoras_vida").val()),
                valoradquisicion: Number($(this).find("#mejoras_importe").val()) || 0
            }; 
            console.log(mejoraData);           
            var amortAcumulada = Amortizacion.getAmortAcumulada(mejoraData);
            var vnc = mejoraData.valoradquisicion - amortAcumulada;
            valorMejoras += mejoraData.valoradquisicion;
            vncMejorasTotal += vnc;
            amortAcumuladaMejorasTotal += amortAcumulada;
            $(this).find("#mejoras_vnc").val(vnc); 
        });
        

        //Valores economicos
        var economicData = {
            fechaAdquisicion: $("#juridicos_fechaAdquisicion").val(),
            vidautil_codigo: Number($("#economicos_vidaUtil").val()),
            valoradquisicion: Number($("#juridicos_costeAdquisicion").val()) || this.model.attributes.juridicos_costeAdquisicion || 0
        };

        var amortAcumulada = Amortizacion.getAmortAcumulada(economicData);
        var vnc = economicData.valoradquisicion - amortAcumulada;
        $("#economicos_valorMejoras").val(valorMejoras);
        $("#economicos_vncBien").val(this.round(vnc));        
        $("#economicos_amorAcumBien").val(this.round(amortAcumulada));
        $("#economicos_vncMejoras").val(this.round(vncMejorasTotal));
        $("#economicos_amorAcumMejoras").val(this.round(amortAcumuladaMejorasTotal));
        $("#economicos_amorAcumTotal").val(this.round(amortAcumulada + amortAcumuladaMejorasTotal));
        $("#economicos_vncTotal").val(this.round(vnc + vncMejorasTotal));

    }, */
    changeMejoras: function(ev) {
        //var fila = $(ev.target).parent("tr");

        var cuenta = $(ev.target).parents("tr").children($("#mejoras_cuenta option:selected")).text();
        //console.log(cuenta);
        var cachos = cuenta.split(" -- ");

        //Miro la CUENTA_XX de la mejora


        $.ajax({
            url: "api/3general/index.php",
            method: "GET",
            data: {
                "_action": "getCuentaInfo",
                "instance": S.instanceId,
                "cuenta": this.model.attributes.epigraph
            },
            success: function(params) {
                if ($(ev.target).parents("tr").find("#mejoras_encurso").is(":checked")) {
                    $(ev.target).parents("tr").find("#mejoras_cuenta option:selected").text(params['cc_encurso'] + " -- " + cachos[1]);
                    $(ev.target).parents("tr").find("#mejoras_vida").val("0");
                    $(ev.target).parents("tr").find("#mejoras_amortizacion").val("0,00");
                    $(ev.target).parents("tr").find("#mejoras_vnc").val("0,00");
                    $(ev.target).parents("tr").find("#mejoras_vida").prop("disabled", true);
                } else {
                    alert('Se modificará la fecha de la mejora al día actual');
                    $(ev.target).parents("tr").find("#mejoras_cuenta option:selected").text(params['cc_inmobil'] + " -- " + cachos[1]);
                    $(ev.target).parents("tr").find("#mejoras_vida").val(params['vida_util']);
                    $(ev.target).parents("tr").find("#mejoras_amortizacion").val(params['amortizacion']);
                    $(ev.target).parents("tr").find("#mejoras_vnc").val("");
                    $(ev.target).parents("tr").find("#mejoras_vida").prop("disabled", false);
                    var hoy = new Date();
                    var dia = hoy.getDate();
                    if (dia < 10)
                        dia = "0" + dia;
                    var mes = hoy.getMonth() + 1;
                    if (mes < 10)
                        mes = "0" + mes;
                    var anio = hoy.getFullYear();
                    var fecha_actual = String(dia + "/" + mes + "/" + anio);

                    $(ev.target).parents("tr").find("#mejoras_fecha").val(fecha_actual);
                }

            }
        })
    },

    saveAmortizaciones: function() {
        // Calculate amortizaciones
        $("#loaderContainer").show();
        var xhr = new XMLHttpRequest();
        var good_id = parseInt(this.model.attributes.id);
        var good_item = parseInt(this.model.attributes.itemId);
        var instance_id = S.instanceId;

        var isEditableam = this.isEditableGood;




        xhr.open('POST', 'api/goods/amortizaciones.php', true);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function(e) {
            if (this.status == 200) {
                // Reload page
                S.mApp.trigger("navigate", {
                    to: "goodDetail",
                    good_id: good_id,
                    lang: currentLang,
                    isEditable: isEditableam
                });
            }
            $("#loaderContainer").hide();
        };
        xhr.send(JSON.stringify({ good_id: good_id, good_item: good_item, instance_id: instance_id }));
        return;



    },
    checkBaja: function(ev) {
        if ($(ev.target).prop("checked")) {
            $("#fechaBaja").prop("disabled", false);
            $("#motivoBaja").prop("disabled", false);
        } else {
            $("#fechaBaja").prop("disabled", true);
            $("#motivoBaja").prop("disabled", true)
        }
    },
    checkCurso: function(ev) {
        if (!$(ev.target).prop("checked")) {
            var d = bootbox.confirm({
                message: S.userInfo.attributes.lang.ACTIVATE_GOOD,
                buttons: {
                    confirm: {
                        label: 'Aceptar',
                        className: 'confirmar_curso'


                    },
                    cancel: {
                        label: 'Cancelar',
                        className: 'cancelar_curso'

                    }
                },
                callback: function(result) {
                    if (result == true) {
                        var hoy = new Date();
                        var dia = hoy.getDate();
                        if (dia < 10)
                            dia = "0" + dia;
                        var mes = hoy.getMonth() + 1;
                        if (mes < 10)
                            mes = "0" + mes;
                        var anio = hoy.getFullYear();
                        var fecha_actual = String(dia + "/" + mes + "/" + anio);

                        $("#fechaCursoFin").val(fecha_actual);
                        $("#enCurso").prop("disabled", true);

                        document.getElementById("vvv").click();

                    } else {
                        $("#enCurso").prop("checked", true);

                    }

                }
            });

        } else {


            this.loadTemplates($('#epigraph').val());
            this.consultaBaja();
        }


    },
    addMejora: function() {
        var textDisabled = 'disabled';
        if (S.userInfo.get("role") == 0) {
            textDisabled = '';
        }

        this.curso = 0;
        this.curso = this.model.attributes.enCurso;


        $("#mejorasList").append('<tr class="valueList">' + MejorasTpl({
            encurso: $('#enCurso').is(':checked'),
            encursoBack: this.curso,
            epi: this.model.attributes.epigraph,
            attributes: {},
            parameters: parametersModel.toJSON(),
            lang: this.lang,
            disabledcheck: textDisabled,
            isnuevamejora: 1

        }) + '</tr>');

        //$(".dtpickerMejoras input").datetimepicker({ format: 'DD/MM/YYYY' });
        //$("#dtpickerMejoras").datetimepicker({ format: 'DD/MM/YYYY' });
        $("#dtpickerAlta, #dtpickerBaja, #dtpickerCursoIni, #dtpickerCursoFin, #dtpickerfechaTitulo, #dtpickerAcuerdos, #dtpickerRegis" +
            "trales, #dtpickerFechaAdquisicion,#dtpickerFechaCesion, #dtpickerfechaVencimiento, #dtpickerSeguroInicio, #dtpickerSeguroVencimiento, #dtpickerPlaneamiento, #dtpickerDerivado, #dtp" +
            "ickerPlanemiento, #dtpickerPlanemientoD, #dtpickerInicio, #dtpickerDocumentos,#dt" +
            "pickerVencimiento, #dtpickerRegistrales, #dtpickerfechaReposicion, #dtpickerfechaRevision, #dtpickerfech" +
            "aMercado,  #dtpickerfechavalorrazonable,  #dtpickerTitulo, #dtpickerMejoras, #dtpickerIncidencias").datetimepicker({ format: 'DD/MM/YYYY' });


        $('.tab-content .money').mask("#.##0,00", { reverse: true });
        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
        $('.tab-content .integer').mask("#.##0", { reverse: true });
        $('.tab-content .number').mask("##0", { reverse: true });
        $('.money').mask("#.##0,00", { reverse: true });
        $('.decimal').mask("#.##0,00", { reverse: true });
        $('.integer').mask("#.##0", { reverse: true });
        $('.number').mask("##0", { reverse: true });

        /////comprobar si puedo borrar o no las mejoras. 

    },
    removeMejora: function(ev) {
        $(ev.target).parents("tr").remove();
        // this.calculateAmortizacion();
    },
    addAcuerdo: function() {
        $("#acuerdosList").append('<tr class="valueList">' + AcuerdosTpl({
            attributes: {},
            parameters: parametersModel.toJSON(),
            lang: this.lang
        }) + '</tr>');
        //$("#dtpickerAcuerdos").datetimepicker({ format: 'DD/MM/YYYY' });
        //$(".dtpickerAcuerdos input").datetimepicker({ format: 'DD/MM/YYYY' });
        $("#dtpickerAlta, #dtpickerBaja, #dtpickerCursoIni, #dtpickerCursoFin, #dtpickerfechaTitulo, #dtpickerAcuerdos, #dtpickerRegis" +
            "trales, #dtpickerFechaAdquisicion,#dtpickerFechaCesion, #dtpickerfechaVencimiento, #dtpickerSeguroInicio, #dtpickerSeguroVencimiento, #dtpickerPlaneamiento, #dtpickerDerivado, #dtp" +
            "ickerPlanemiento, #dtpickerPlanemientoD, #dtpickerInicio, #dtpickerDocumentos,#dt" +
            "pickerVencimiento, #dtpickerRegistrales, #dtpickerfechaReposicion, #dtpickerfechaRevision, #dtpickerfech" +
            "aMercado,  #dtpickerfechavalorrazonable,  #dtpickerTitulo, #dtpickerMejoras, #dtpickerIncidencias").datetimepicker({ format: 'DD/MM/YYYY' });

    },
    removeAcuerdo: function(ev) {
        $(ev.target).parents("tr").remove();
    },
    addCatastral: function() {

        $("#catastralesList").append('<tr class="valueList">' + CatastralesTpl({
            attributes: {},
            parameters: parametersModel.toJSON(),
            lang: this.lang,
        }) + '</tr>');

        $('.tab-content .money').mask("#.##0,00", { reverse: true });
        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
        $('.tab-content .integer').mask("#.##0", { reverse: true });
        $('.tab-content .number').mask("##0", { reverse: true });

        $('.money').mask("#.##0,00", { reverse: true });
        $('.decimal').mask("#.##0,00", { reverse: true });
        $('.integer').mask("#.##0", { reverse: true });
        $('.number').mask("##0", { reverse: true });

    },
    removeCatastral: function(ev) {
        $(ev.target).parents("tr").remove();
    },
    addRegistral: function() {
        $("#registralesList").append('<tr class="valueList">' + RegistralesTpl({
            attributes: {},
            parameters: parametersModel.toJSON(),
            lang: this.lang
        }) + '</tr>');

        //$("#dtpickerRegistrales").datetimepicker({ format: 'DD/MM/YYYY' });
        //$(".dtpickerRegistrales input").datetimepicker({ format: 'DD/MM/YYYY' });
        $("#dtpickerAlta, #dtpickerBaja, #dtpickerCursoIni, #dtpickerCursoFin, #dtpickerfechaTitulo, #dtpickerAcuerdos, #dtpickerRegis" +
            "trales, #dtpickerFechaAdquisicion,#dtpickerFechaCesion, #dtpickerfechaVencimiento, #dtpickerSeguroInicio, #dtpickerSeguroVencimiento, #dtpickerPlaneamiento, #dtpickerDerivado, #dtp" +
            "ickerPlanemiento, #dtpickerPlanemientoD, #dtpickerInicio, #dtpickerDocumentos,#dt" +
            "pickerVencimiento, #dtpickerRegistrales, #dtpickerfechaReposicion, #dtpickerfechaRevision, #dtpickerfech" +
            "aMercado,  #dtpickerfechavalorrazonable,  #dtpickerTitulo, #dtpickerMejoras, #dtpickerIncidencias").datetimepicker({ format: 'DD/MM/YYYY' });


        $('.tab-content .money').mask("#.##0,00", { reverse: true });
        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
        $('.tab-content .integer').mask("#.##0", { reverse: true });
        $('.tab-content .number').mask("##0", { reverse: true });
        $('.money').mask("#.##0,00", { reverse: true });
        $('.decimal').mask("#.##0,00", { reverse: true });
        $('.integer').mask("#.##0", { reverse: true });
        $('.number').mask("##0", { reverse: true });
    },
    removeRegistral: function(ev) {
        $(ev.target).parents("tr").remove();
    },
    addTitulo: function() {

        $("#titulosList tbody").append('<tr class="valueList">' + TitulosTpl({
            attributes: {},
            parameters: parametersModel.toJSON(),
            lang: this.lang
        }) + '</tr>');

        $("#dtpickerAlta, #dtpickerBaja, #dtpickerCursoIni, #dtpickerCursoFin, #dtpickerfechaTitulo, #dtpickerAcuerdos, #dtpickerRegis" +
            "trales, #dtpickerFechaAdquisicion,#dtpickerFechaCesion, #dtpickerfechaVencimiento, #dtpickerSeguroInicio, #dtpickerSeguroVencimiento, #dtpickerPlaneamiento, #dtpickerDerivado, #dtp" +
            "ickerPlanemiento, #dtpickerPlanemientoD, #dtpickerInicio, #dtpickerDocumentos,#dt" +
            "pickerVencimiento, #dtpickerRegistrales, #dtpickerfechaReposicion, #dtpickerfechaRevision, #dtpickerfech" +
            "aMercado,  #dtpickerfechavalorrazonable,  #dtpickerTitulo, #dtpickerMejoras, #dtpickerIncidencias").datetimepicker({ format: 'DD/MM/YYYY' });

        //$("#dtpickerfechaTitulo").datetimepicker({ format: 'DD/MM/YYYY' });
        //$(".dtpickerTitulo input").datetimepicker({ format: 'DD/MM/YYYY' });
        $('.tab-content .money').mask("#.##0,00", { reverse: true });
        $('.tab-content .decimal').mask("#.##0,00", { reverse: true });
        $('.tab-content .integer').mask("#.##0", { reverse: true });
        $('.tab-content .number').mask("##0", { reverse: true });

        $('.money').mask("#.##0,00", { reverse: true });
        $('.decimal').mask("#.##0,00", { reverse: true });
        $('.integer').mask("#.##0", { reverse: true });
        $('.number').mask("##0", { reverse: true });


    },
    removeTitulo: function(ev) {
        $(ev.target).parents("tr").remove();
    },
    addDocument: function() {
        $("#documentosList tbody").append(DocumentTpl({
            attributes: {},
            lang: this.lang,
            t_oken: S.token
        }));

        $(".dtpickerDocumentos input").datetimepicker({ format: 'DD/MM/YYYY' });
    },
    removeDocument: function(ev) {
        $(ev.target).parents(".documentosItem").remove();
    },
    round: function(num) {
        var mynum = Math.round(num * 1000) / 1000;
        var format = require('format-number');
        var myFormat = format({ prefix: '', suffix: '', integerSeparator: '.', decimal: ',', padRight: 2 });
        var formattedNumber = myFormat(mynum, { noSeparator: false });
        return formattedNumber;
    },
    tabView: function() {
        $("#Tabs").show();
        $(".listHeader").hide();
        $(".tab-pane").removeClass("tabList");
        $("#wrapper").height(window.innerHeight);
    },
    listView: function() {
        $("#Tabs").hide();
        $(".listHeader").show();
        $(".tab-pane").addClass("tabList");
        $("#wrapper").height(window.innerHeight);
        this.showMap();
    },
    changeForms: function(ev) {

        $('#lab_epigra_tte').val($(ev.target).val());
        this.loadTemplates($(ev.target).val());
        this.consultaBaja();
    },
    changeForms2: function() {


        $.ajax({
            url: "api/3general/index.php",
            method: "GET",
            data: {
                "_action": "getCuentaInfo",
                "instance": S.instanceId,
                "cuenta": this.model.attributes.epigraph
            },
            success: function(params) {

                $("#economicos_cuenta option:selected").text(params["cc_inmobil"] + " -- " + params["cuenta"]);

                $("#economicos_vidaUtil").val(params["vida_util"]);
                $("#economicos_amortizacion").val(params["amortizacion"]);

                $("#mejorasList tbody tr").each(function() {
                    var hoy = new Date();
                    var dia = hoy.getDate();
                    if (dia < 10)
                        dia = "0" + dia;
                    var mes = hoy.getMonth() + 1;
                    if (mes < 10)
                        mes = "0" + mes;
                    var anio = hoy.getFullYear();
                    var fecha_actual = String(dia + "/" + mes + "/" + anio);

                    $(this).find("#mejoras_fecha").val(fecha_actual);
                    $(this).find("#mejoras_vida").val(params["vida_util"]);
                    $(this).find("#mejoras_amortizacion").val(params["amortizacion"]);
                    $(this).find("#mejoras_vnc").val();
                    $(this).find("#mejoras_cuenta option:selected").text(params["cc_inmobil"] + " -- " + params["cuenta"]);

                    $(this).find("#mejoras_encurso").prop("checked", false);
                    $(this).find("#mejoras_encurso").prop("disabled", false);

                });
            }
        });


    },

    submit: function(ev) {

        var costeadquisi = $.trim($('#juridicos_costeAdquisicion').val());

        if ($.isNumeric(parseFloat(costeadquisi))) {
            if (parseFloat(costeadquisi) > 0) {

                if ($.trim($('#juridicos_fechaAdquisicion').val())) {} else {

                    $("#juridicos_fechaAdquisicion").addClass("  validationError ");
                    S.mApp.trigger("notify:error", { message: S.userInfo.attributes.lang.VALIDATION_ERROR });

                    return;
                }
            }
        }


        if (ev)
            ev.preventDefault();

        errorRequiredFields = []; // Reset required fields with errors
        $('.validationError').removeClass("validationError");

        this.files = [];
        this.formData = {};
        this.formData = this.iterateForm(document.forms["goods"]);
        _.extend(this.formData, (this.iterateForm(document.forms["descriptivos"])));
        this.formData["acuerdos"] = this.iterateMasters("acuerdos");

        //this.formData["ampliada"] = this.iterateForm(document.forms["ampliada"]);

        this.formData["incidencias"] = this.iterateForm(document.forms["incidencias"]);

        this.formData["catastrales"] = this.iterateMasters("catastrales");
        _.extend(this.formData, this.iterateForm(document.forms["economicos"]));
        this.formData["gps"] = this.iterateForm(document.forms["gps"]);
        _.extend(this.formData, this.iterateForm(document.forms["juridicos"]));
        this.formData["registrales"] = this.iterateMasters("registrales");
        this.formData["seguros"] = this.iterateForm(document.forms["seguros"]);
        this.formData["titulos"] = this.iterateMasters("titulos");
        this.formData["urbanisticos"] = this.iterateForm(document.forms["urbanisticos"]);
        this.formData["mejoras"] = this.iterateMasters("mejoras");
        this.formData["documentos"] = this.iterateDocuments(document.forms["documentos"]);

        if (errorRequiredFields.length) {
            $.each(errorRequiredFields, function() {
                $("#" + this).addClass("validationError");
            });
            // NOT scrolling, maybe bootstrap tap issue
            /* $('html, body').animate({
                scrollTop: $('.validationError:visible:first').offset().top + 100 }, {                
                duration: 1000,
                complete: function(){
                    S.mApp.trigger("notify:error", { message: S.userInfo.attributes.lang.INSERT_ERROR });
                }
            }); */
            S.mApp.trigger("notify:error", { message: S.userInfo.attributes.lang.VALIDATION_ERROR });
        } else {

            var thisAlias = this;
            // Confirm
            bootbox.confirm(S.userInfo.attributes.lang.SAVING_CONFIRM, function(confirmationResult) {
                if (confirmationResult) {
                    thisAlias.model.set(thisAlias.formData);
                    //loadFile will trigger "formReady" in every case
                    thisAlias.loadFiles();
                }
            });
        }
    },
    iterateMasters: function(section) {



        var formData = [];
        // $("#" + section + "List tr:not(tr:first-child)").each(function() {
        $("#" + section + "List tr.valueList").each(function() {
            var line = {};
            $(this).find("input").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });
            $(this).find("textarea").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });
            $(this).find("select").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });

            if ($(this).find("#mejoras_encurso").val() === "on") {

                line["mejoras_encurso"] = $(this).find("#mejoras_encurso").is(':checked') ?
                    "1" :
                    "0";

            }

            formData.push(line);
        });


        return formData;
    },
    iterateDocuments: function() {
        var formData = [];
        $(".documentosItem").each(function() {
            var line = {};
            $(this).find("input").each(function() {
                if ($(this).attr("type") === "file")
                    return;

                line[$(this).attr("id")] = $(this).val();
            });

            $(this).find("textarea").each(function() {
                line[$(this).attr("id")] = $(this).val();
            });

            formData.push(line);
        });

        return formData;
    },
    iterateForm: function(form) {
        var formData = {};

        for (var i = 0; i < form.elements.length; i++) {
            var element = form.elements[i];
            if (element.nodeName === "BUTTON")
                continue;
            else
            // If it is file, leave for later
            if ($(element).attr("type") === "file" && $(element)[0].files[0]) {
                continue;
            } else
            //In case of date, format correctly
            if ($(element).attr("id") && $(element).attr("id").indexOf("fecha") !== -1) {



                if (($(element).attr("id") == 'juridicos_fechaAdquisicion') || ($(element).attr("id") == 'economicos_fechavalorrazonable')) {

                    if (!$(element).val() || $(element).val() === "00/00/0000" || $(element).val() === "") {

                        formData[$(element).attr("id")] = "";
                    }
                } else {

                    if (!$(element).val() || $(element).val() === "00/00/0000" || $(element).val() === "") {
                        continue;
                    }
                }


                ////continue;
                /*var fecha = $(element).val().split("/");
        formData[$(element).attr("id")] = fecha[2] + "-" + fecha[1] + "-" + fecha[0];
        continue;*/
            } else
            //If checkbox, tranform to boolean
            if ($(element).val() === "on") {
                formData[$(element).attr("id")] = $(element).is(':checked') ?
                    "1" :
                    "0";
                continue;
            }

            if ((requiredFields.indexOf($(element).attr("id")) >= 0) && !$(element).val())
                errorRequiredFields.push($(element).attr("id"));

            formData[$(element).attr("id")] = $(element).val();
        }

        return formData;
    },
    //Recuento de ficheros
    loadFiles: function() {
        var files = [];
        $(".documentosItem #documento_file").each(function() {
            if (this.files.length) {
                this.files[0].id = this.getAttribute("id");
                files.push(this.files[0]);
            } else {
                files.push("");
            }

        });

        if (!files.length) {
            S.mApp.trigger("formReady");
            return;
        }

        var j = files.length - 1;

        var self = this;

        //Recursively load files and fire formReady when done
        function loadFile() {
            if (j === -1 || !files[j].id) {
                S.mApp.trigger("formReady");
            } else {
                var reader = new FileReader();
                reader.fileId = files[j].id;
                reader.name = files[j].name;

                reader.readAsDataURL(files[j]);

                reader.onload = function() {
                    self.formData.documentos[j].file = {
                        base64: reader.result,
                        name: reader.name,
                        type: "file"
                    };
                    j--;

                    loadFile();
                };
            }
        }

        loadFile();
    },
    formReady: function() {

        var isEditable = this.isEditableGood;

        if (this.snap) {
            this.model.set({
                //Base64 got directly from image source
                snap: {
                    "base64": $("#snapShot").attr("src"),
                    "extension": $("#snapShot").attr("data-ext")
                }
            });
        }

        // / CHECK DIFFERENCES WITH THE ORIGINAL MODEL TO WRITE CHANGES
        // /////////////////////////////////////////////////////////////////// /
        function deepDiff(a, b, r, reversible) {
            _.each(a, function(v, k) {
                try {
                    // already checked this or equal...
                    if (r.hasOwnProperty(k) || b[k] === v)
                        return;
                } catch (e) {
                    //Continue when error
                    return;
                }

                // but what if it returns an empty object? still attach?
                r[k] = _.isObject(v) ? _.diff(v, b[k], reversible) : v;
            });
        }

        /* the function */
        _.mixin({
            shallowDiff: function(a, b) {
                return _.omit(a, function(v, k) {
                    return b[k] === v;
                });
            },
            diff: function(a, b, reversible) {
                var r = {};
                deepDiff(a, b, r, reversible);
                if (reversible)
                    deepDiff(b, a, r, reversible);
                return r;
            }
        });

        var changes = _.diff(this.model.toJSON(), storeModel.toJSON());
        for (var i in changes) {
            if (typeof changes[i] === "object" && !_.size(changes[i]))
                delete changes[i];
        }

        //Clean binary files content from changes. Not needed
        if (changes["snap"])
            delete changes["snap"]["file"];

        /// Register changed data when editing
        if (this.model.id)
            this.model.set({ "changedItems": changes });

        var currentLang = this.lang;

        this.model.save({
            instanceId: S.instanceId
        }, {
            beforeSend: T.useToken,
            success: function(data, status) {
                S.mApp.trigger("notify:success", { message: S.userInfo.attributes.lang.INSERT_OK });
                // Reload


                S.mApp.trigger("navigate", {
                    to: "goodDetail",
                    good_id: status,
                    lang: currentLang,
                    isEditable: isEditable
                });
                // $("#itemId").val(status);
            },
            error: function(data, status) {
                if (status.status == 444) {
                    S.mApp.trigger("notify:error", { message: S.userInfo.attributes.lang.BAJAS_ERROR });
                } else

                    S.mApp.trigger("notify:error", { message: S.userInfo.attributes.lang.INSERT_ERROR });
            }
        });
    },
    //Force redraw when GPS tab is shown
    showMap: function() {
        if (this.map) {
            var center = this.map.getCenter();
            google.maps.event.trigger(this.map, "resize");
            this.map.setCenter(center);
        }
    },
    checkFile: function(ev) {
        var reader = new FileReader();
        var file = ev.target.files[0];
        if (!file)
            return;

        var extension = file.name.split(".");
        extension = extension[extension.length - 1];
        if (extension !== "jpg" && extension !== "png" && extension !== "gif") {
            alert("Debe ser formato de imágen");
            return;
        }

        this.snap = true;

        reader.onload = function() {
            this.data = reader.result;
            $("#snapShot").attr("data-ext", extension);
            $("#snapShot").attr("src", this.data);
        }.bind(this);

        reader.readAsDataURL(file);
    },
    historyList: function(ev) {
        ev.stopPropagation();
        if (!$("#historyList").is(':visible')) {
            $("#loaderContainer").show();
            logModel.set({ id: this.model.attributes.itemId });
            logModel.fetch({
                data: {
                    column: 'fecha_modificado',
                    order: 'desc',
                    instanceId: S.instanceId
                },
                beforeSend: T.useToken,
                success: function() {
                    $("#historyList").show();
                    $("#loaderContainer").hide();

                    if (_.size(logModel.attributes) > 2) {
                        $("#historyList").html("");
                        var records = logModel.attributes;
                        for (var i in records) {
                            var disabled;
                            if (records[i].id === this.model.id)
                                continue;

                            if (!isNaN(i))
                                $("#historyList").append('<li><a id="' + records[i].id + '"><span class="label label-primary">' + records[i].operacion + '</span> ' + records[i].fecha_modificado + '</a></li><li role="separator" class="divider"></li>');

                        }
                    } else {
                        $("#historyList")
                            .html("")
                            .append('<li><a>' + this.lang.NORECORDS + '</a></li>');
                    }

                }.bind(this),
                error: function() {
                    $("#loaderContainer").hide();
                }
            });
        } else {
            $("#historyList").hide();
        }

    },
    hideOptions: function() {
        $("#historyList").hide();
    },
    selectHistory: function(ev) {
        this.model.set({
            id: $(ev.target).attr("id")
        });

        this.model.fetch({
            data: {
                instanceId: S.instanceId
            },
            beforeSend: T.useToken,
            success: this.applyView.bind(this)
        });
    },
    clone: function() {
        var resp = confirm(this.lang.CLONE_WARNING);
        if (!resp)
            return;

        $("#itemId").val('');
        this.model.clear();
        this.submit();
    },
    changeVidaUtill: function() {


        if (S.userInfo.get("role") == 0) {

            var valorRazo = parseInt($('#economicos_valorrazonable').val());


            if (valorRazo >= 0) {
                $('#economicos_vidaUtil').prop("disabled", false);
            } else {
                $('#economicos_vidaUtil').prop("disabled", true);
                $('#economicos_vidaUtil').val('0');
            }

        }

    },


    _checkDisableSections: function() {

        var requiredFields = [
            "entity"

        ];

        /////SOLO PARA EL USUARIO NORMAL 
        if (S.userInfo.attributes.role > 2) {

            var params = {
                '_action': 'validate_sections',
                '_epigraf': this.model.attributes.epigraph,
                '_iduser': S.userInfo.attributes.id,
                '_idinstance': S.instanceId
            }

            $.ajax({
                url: 'api/3general/index.php',
                type: 'GET',
                data: params,
                success: function(resp, statut, XRS) {


                    //////$('form#descriptivos').css({ 'border': '1px solid blue' });

                    $.each(resp[0], function(key, valuekey) {

                        ////no selection 
                        if (valuekey == 0) {

                            if (key == 'documentos') {
                                $('form#' + key).find('input:not(:hidden)').each(function(keyyy, valueee) {

                                    $(this).prop('disabled', true);
                                });

                            } else {

                                $('form#' + key).find('input').each(function(keyyy, valueee) {

                                    $(this).prop('disabled', true);
                                });

                            }



                            $('form#' + key).find('select').each(function(keyyy, valueee) {

                                $(this).prop('disabled', true);
                            });

                            $('form#' + key).find('textarea').each(function(keyyy, valueee) {

                                $(this).prop('disabled', true);
                            });


                            $('form#' + key).find('button').hide();
                            $('form#' + key).find('unbreakable').hide();
                            $('form#' + key + ' .unbreakable').hide();

                        }




                        if (key == 'descriptivos' && valuekey == 1) {
                            requiredFields.push('denominacion');
                        }

                        if (key == 'juridicos' && valuekey == 1) {
                            requiredFields.push('juridicos_situacionPatrimonial');
                            requiredFields.push('juridicos_uso');
                            requiredFields.push('juridicos_tipoAdquisicion');
                            requiredFields.push('juridicos_fechaAdquisicion');
                        }


                    });






                },
                error: function(resultat, statut, erreur) {

                }

            });

        } else {
            ////SI NO ES USUARIO NORMAL QUE VALIDE SIEMPRE LO QUE TENGA QUE VALIDAR. 
            requiredFields.push('denominacion');
            requiredFields.push('juridicos_situacionPatrimonial');
            requiredFields.push('juridicos_uso');
            requiredFields.push('juridicos_tipoAdquisicion');
            requiredFields.push('juridicos_fechaAdquisicion');
        }




    },


    changePorcenAmortiza: function() {

        if (S.userInfo.get("role") == 0) {

            var vidaUtilC = parseInt($('#economicos_vidaUtil').val());


            if (vidaUtilC > 0) {
                var porcentaAmortiza = 100 / vidaUtilC;
                porcentaAmortiza = porcentaAmortiza.toFixed(2);
                porcentaAmortiza = porcentaAmortiza.replace(".", ",");

                $('#economicos_amortizacion').val(porcentaAmortiza);

            } else {

                $('#economicos_vidaUtil').val('0');
                $('#economicos_amortizacion').val('0');
            }

        }


    },


    Changemejoras_vida: function(evt) {
        var valyearvida = $(evt.target).val();



        if (valyearvida > 0) {
            $(($(evt.target).parent()).parent()[0]).find('td').each(function(column, td) {



                if ($(this).find('input[id=mejoras_amortizacion]')) {
                    var newPorcenta = 100 / valyearvida;
                    newPorcenta = newPorcenta.toFixed(2);



                    $(this).find('input[id=mejoras_amortizacion]').val(newPorcenta)

                }

            });
        }

    },
    exportPDF: function(ev) {


        var idGood = document.getElementById('id_good_id_x').value;
        var listGood = idGood.split("_");

        if (listGood[0] > 0) {

            S.mApp.trigger("navigate", {
                to: "pdfView",
                //goods: [$("#itemId").val()],

                goodsID: [$("#itemId").val()],
                goods: [listGood[0]],
                lang: this.lang,
                viewable: this.isEditableGood
            });



        }




    },
    regions: {
        "descriptivos": "#descriptivos",

        "incidencias": "#incidencias",
        "economicos": "#economicos",
        "gps": "#gps",
        "juridicos": "#juridicos",
        "seguros": "#seguros",
        "urbanisticos": "#urbanisticos",
        "titulos": "#titulos",
        "acuerdos": "#acuerdos",
        "registrales": "#registrales",
        "catastrales": "#catastrales",
        "mejoras": "#mejoras",
        "documentos": "#documentos"
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/goodsDetail/goodsDetailView.js
// module id = 183
// module chunks = 0